import type { WidgetInstance } from './widget';

export function destroy(instance: WidgetInstance | null | undefined): void {
  instance?.destroy();
}